<template>
  <div id="app" :class="pageClass">
    <MenuBar />

    
    <router-view />

    <footer class="footer" v-if="home">
      <div class="footer-content">
        <div class="footer-icons">

          <a href="https://twitter.com/@xsint-intelli" target="_blank" class="footer-icon">
            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M22.46 6c-.77.34-1.6.56-2.46.67.88-.53 1.56-1.36 1.88-2.35-.82.5-1.74.87-2.71 1.07a4.28 4.28 0 0 0-7.29 3.91A12.11 12.11 0 0 1 3 4.82a4.22 4.22 0 0 0 1.33 5.71A4.14 4.14 0 0 1 2.8 10v.06a4.27 4.27 0 0 0 3.43 4.18c-.67.18-1.4.2-2.15.08a4.29 4.29 0 0 0 4 3 8.57 8.57 0 0 1-5.33 1.84A9 9 0 0 0 8 20c5.88 0 9.1-4.86 9.1-9.09 0-.14-.01-.28-.02-.41A6.47 6.47 0 0 0 22.46 6z" />
            </svg>
          </a>

          <a href="mailto:contant@xsint-intelligence.com"  target="_blank" ><i class="mdi mdi-email"></i></a>
          <a href="https://www.youtube.com/@XSINT-INTELLIGENCE"  target="_blank" ><i class="mdi mdi-youtube"></i></a>

        </div>
        <div class="footer-links">
          <router-link to="/terms" class="footer-link">Terms & Conditions</router-link>
        </div>
      </div>
    </footer>


  </div>

  
</template>
<script>
import MenuBar from "./components/menu_bar_2hor.vue";

export default {
  name: "App",
  components: {
    MenuBar,
  },
  computed: {
    home() {
      return (
        !this.$route.path.includes("lookup") &&
        !this.$route.path.includes("updates") &&
        !this.$route.path.includes("discord-bot") &&
        !this.$route.path.includes("register")  &&
        !this.$route.path.includes("login") &&
        !this.$route.path.includes("forgot-password") &&
        !this.$route.path.includes("reset-password") &&
        !this.$route.path.includes("/")
      );
    },
    pageClass() {
      const routePath = this.$route.path;
      if (
        routePath.includes("updates") ||
        routePath.includes("lookup") 


      ) {
        return "updates-page";
      }
      return "default-page";
    },
  },
};
</script>
<style>
/* Fond par défaut */
.default-page {
  background: url("/public/backxsint.jpg") no-repeat center center fixed;
  
}

/* Fond pour la page des mises à jour */
.updates-page {
  background: url("/public/updates.png") no-repeat center center fixed;
}

/* Assurez-vous que le contenu s'affiche bien */
#app {
  
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
}

.footer {
  background-color: #1414142c;
  color: white;
  text-align: center;
  padding: 20px 0;
  position: relative;
  bottom: 0;
  width: 100%;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.footer-icons {
  display: flex;
  gap: 15px;
}

.footer-icon svg {
  fill: white;
  transition: fill 0.3s ease;
}

.footer-icon svg:hover {
  fill: #006eff;
}

.footer-links {
  display: flex;
  gap: 20px;
}

.footer-link {
  color: white;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #006eff;
}
</style>
